import { Navbar, Container } from "react-bootstrap";
import { FaChartBar } from "react-icons/fa";
import logo from "./Satta King.png";

function Header() {
  return (
    <Navbar bg="black" variant="dark" expand="lg" className="shadow-sm p-0">
      <Container className="p-0">
        <Navbar.Brand className="text-center m-auto">
          <img src={logo} alt="punjab night satta king" className="w-10" />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}

export default Header;